// import * as React from 'react';
import React, {createContext, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import axios from 'axios';
import SecureWebStorage from 'secure-web-storage';


import {getValueByPath, isBlank, isNotBlank} from './utils/Utils';
import {dictionary} from './api/DictionaryApi';
import {translations} from './utils/Localisation';

import {getAuth, isAuthenticated, setAuth} from './store/AuthSlice';
import {getSystemSettings, getUserSettings, modifySettings} from './store/SettingsSlice';
import {getCurrentUser, setCurrentUser} from './store/CommonSlice';
// import {getTheme} from './store/StyleSlice';
// import {ConfirmationDialog} from './elements/ConfirmationDialog';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import {message} from "antd";
import {AppLayout} from "./layout/AppLayout";

dayjs.locale('ru');

export const ApiContext = createContext();
const PROGRES_KEY = 'PROGRES_KEY';
const MESSAGE_MARGINE_TOP = '-12px';

var CryptoJS = require("crypto-js");

var SECRET_KEY = '1324123ADFSDAfdsf adfa a!@#$!%#$$';

var secureStorage = null;


secureStorage = new SecureWebStorage(localStorage, {
    hash: function hash(key) {
        key = CryptoJS.SHA256(key, SECRET_KEY);

        return key.toString();
    },
    encrypt: function encrypt(data) {
        data = CryptoJS.AES.encrypt(data, SECRET_KEY);

        data = data.toString();

        return data;
    },
    decrypt: function decrypt(data) {
        data = CryptoJS.AES.decrypt(data, SECRET_KEY);

        data = data.toString(CryptoJS.enc.Utf8);

        return data;
    }
});


// включить крутилку
const showProgress = (progresKey) => {
    if (progresKey == null) progresKey = PROGRES_KEY;
    message.loading({
        key: progresKey,
        content: '...',
        duration: 10,  // на случай если что-то заглючит, чтобы закрылось сообщение
        style: {marginTop: MESSAGE_MARGINE_TOP}
    });
};

// выключить крутилку
const hideProgress = (progresKey) => {
    if (progresKey == null) progresKey = PROGRES_KEY;
    message.destroy(progresKey);
};

// показать ошибку
const showError = (msg) => {
    message.error({
        content: msg,
        duration: 5,
        style: {marginTop: MESSAGE_MARGINE_TOP}
    });
};

// показать предупреждение
const showWarning = (msg) => {
    message.warning({
        content: msg,
        duration: 4,
        style: {marginTop: MESSAGE_MARGINE_TOP}
    });
};

// показать информационное сообщение
const showInfo = (msg) => {
    message.info({
        content: msg,
        duration: 3,
        style: {marginTop: MESSAGE_MARGINE_TOP}
    });
};

// показать сообщение об успешном завершении
const showSuccess = (msg) => {
    message.success({
        content: msg,
        duration: 2,
        style: {marginTop: MESSAGE_MARGINE_TOP}
    });
};

// вывести сообщение в консоль (чтобы потом в одном месте отключить для прода или если захотим их передавать на сервер)
const log = (msg, data) => {
    console.log(msg, data);
};

// вывести ошибку в консоль (чтобы потом в одном месте отключить для прода или если захотим их передавать на сервер)
const logError = (msg, data) => {
    console.error(msg, data);
};

var requestInterceptor = null;
var responseInterceptor = null;

export const ApiProvider = ({children}) => {
    const dispatch = useDispatch();
    const authRef = useRef();
    authRef.current = useSelector(getAuth);
    const authenticatedRef = useRef();
    authenticatedRef.current = useSelector(isAuthenticated);
    const auth = useSelector(getAuth);
    const settings = useSelector(getSystemSettings);
    const userSettings = useSelector(getUserSettings);
    const currentUser = useSelector(getCurrentUser);

    // const theme = useSelector(getTheme);

    const authHeaders = useRef();
    const authData = useRef();

    const txt = (msg) => {
        if (isBlank(msg)) return '';
        let ret = getValueByPath(translations, userSettings.locale + '.' + msg);
        if (ret == null) {
            ret = getValueByPath(translations, 'en' + '.' + msg);
            if (ret != null) {
                return ret;
            }
            return msg;
        } else {
            return ret;
        }
    }

    // get localizated text 
    const translate = (object, value, mn) => {
        if (isBlank(value)) return '';
        if (isBlank(mn)) mn = 'name';
        return getValueByPath(translations, userSettings.locale + '.' + object + '.' + value + '.' + mn) ||
            getValueByPath(translations, 'en.' + object + '.' + value + '.' + mn) || value || '';
        // return getValueByPath(translations, `${userSettings.locale}.${object}.${value}.${mn}`) || '';
    }

    // const getImageSource = (image) => getImageSourceByThemeAndLocale(theme, userSettings.locale, image)


    const saveToStore = async (key, value) => {
        try {
            //todo раскомментить
            // secureStorage.setItem(key, value);
        } catch (error) {
            showError(`Failed to save ${key}: ${error}`);
        }
    };

    const getFromStore = async (key) => {
        try {
            return secureStorage.getItem(key);
        } catch (error) {
            showError(`Failed to get ${key}: ${error}`);
        }
    };

    // const saveTheme = (value) => {
    //     saveToStore('theme', value);
    // };

    const saveLoginInfo = (genericResponse, loginByHand) => {
        if (genericResponse.error == '') {
            const currentTime = new Date();
            const accessTokenExpDate = new Date(currentTime.getTime() + genericResponse.data.expires_in * 1000);
            const refreshTokenExpDate = new Date(currentTime.getTime() + genericResponse.data.refresh_expires_in * 1000);
            dispatch(
                setAuth({
                    accessToken: genericResponse.data.access_token,
                    refreshToken: genericResponse.data.refresh_token,
                    accessTokenExpDate: accessTokenExpDate.toISOString(),
                    refreshTokenExpDate: refreshTokenExpDate.toISOString(),
                    loginByHand: loginByHand,
                })
            );
            saveToStore('access_token', genericResponse.data.access_token);
            saveToStore('refresh_token', genericResponse.data.refresh_token);
            saveToStore('accessTokenExpDate', accessTokenExpDate.toISOString());
            saveToStore('refreshTokenExpDate', refreshTokenExpDate.toISOString());
        }
    };

    // fixme нормально написать
    const afterLogin = (genericResponse) => {
        if (genericResponse.error == '') {
            saveLoginInfo(genericResponse, true);  // установим признак того что человек прилогинился сам, а не автоматом по ранее сохраненным токенам

            // todo сделать переход на home и удалить историю чтобы не вернуться назад
            // navigate("/home")
            // // navigation.replace('HomePage');
            // navigation.navigate('HomePage');
        }
    };

    // обновить access token by refresh token
    async function doRefreshToken() {
        // const refreshHeaders = { ...{ 'Content-Type': 'application/json', Accept: 'application/json' }, ...authHeaders.current };
        const refreshHeaders = {'Content-Type': 'application/json', Accept: 'application/json'};
        const axiosInstance = axios.create({
            baseURL: settings.server,
            headers: refreshHeaders,
        });
        axiosInstance.interceptors.response.use(
            response => {
                const url = response.config.url;
                // hideProgress(url);
                if (response.data.error) {
                    logError(url + '->error', response.data);
                    showError(response.data.error);
                    // dispatch(setLastErrorData(response.data));
                } else {
                    log(url + '->ok', response.data);
                }
                // dispatch(setBusy(false));
                return response.data;
            },
            error => {
                logError(error.config.url + '->catch', error);
                // hideProgress(error.config.url);
                // dispatch(setBusy(false));
                showError("" + error);
                return Promise.reject(error);
            }
        );
        const body = {access_token: authData.current?.accessToken, refresh_token: authData.current?.refreshToken};
        try {
            const genericResponse = await axiosInstance.post('/user/refresh_token', body);
            if (genericResponse != null && genericResponse.error == '') {
                saveLoginInfo(genericResponse);
                authHeaders.current = {
                    Authorization: `Bearer ${genericResponse.data.access_token}`,
                };
            }
        } catch (error) {
            logError('refrsh_token->catch', error);
            showError("" + error);
        }
    }

    // данный useEffect отрабатывает после регистрации пользователя (при вводе логина или автоматически из сохраненных данных)
    useEffect(() => {
        // console.log('auth?.accessToken', auth?.accessToken);
        if (auth?.accessToken) {
            authHeaders.current = {
                Authorization: `Bearer ${auth.accessToken}`,
            };
            if (isBlank(currentUser?.uuid)) {  // Если данные текущего пользователя не загружены
                axios.get('/api/v1/current-user')  // получим их
                    .then((genericResponse) => {

                        // сохраним данные по текущему пользователю в стейт
                        dispatch(setCurrentUser(genericResponse.data));
                    }).catch(error => {
                });
            }
            axios.get('/api/v1/current-user/setting')  // получим настройки
                .then((genericResponse) => {
                    if (genericResponse.data != null && Array.isArray(genericResponse.data) && genericResponse.data.length > 0) {
                        const settingObj = {};
                        for (let setting of genericResponse.data) {
                            if (settingObj[setting.settingType] == null) {
                                settingObj[setting.settingType] = {};
                            }
                            settingObj[setting.settingType][setting.code] = setting.value
                        }
                        console.log('settingObj = ', settingObj);
                        // сохраним настройки в стейт
                        dispatch(modifySettings(settingObj));
                    }
                }).catch(error => {
            });
        } else {
            authHeaders.current = {};
        }
        authData.current = auth;
        // console.log('authHeaders-set', authHeaders.current);
    }, [authenticatedRef.current, auth]);

    var headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    };

    var downloadHeaders = {
        'Content-Type': 'application/json',
        Accept: 'application/octet-stream',
    };

    var uploadHeaders = {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
    };

    if (axios.defaults.baseURL == null || axios.defaults.baseURL == '') {
        axios.defaults.baseURL = settings.server;
    }

    useEffect(() => {
        axios.defaults.baseURL = settings.server;
        console.log('settings.server = ', settings.server);
    }, [settings.server]);

    if (requestInterceptor == null) {
        requestInterceptor = axios.interceptors.request.use(async function (config) {
            if (isNotBlank(authData.current?.accessTokenExpDate) && !config.url.includes("/logout")) {
                const accessTokenExpDate = new Date(Date.parse(authData.current?.accessTokenExpDate));
                let currentTime = new Date();
                currentTime = new Date(currentTime.getTime() + 1200000);  // 20 минут в будущем, для сравнения с временем экспирации токена
                if (accessTokenExpDate < currentTime) {
                    // попробуем обновить токен
                    await doRefreshToken();
                }
            }
            // showProgress(config.url);
            if (config.url.includes("/download")) {
                config.headers = {...headers, ...downloadHeaders, ...authHeaders.current};
            } else if (config.url.includes("/upload")) {
                config.headers = {...headers, ...uploadHeaders, ...authHeaders.current};
            } else {
                config.headers = {...headers, ...authHeaders.current};
            }
            config.timeout = 5000; // Set the timeout to 5 seconds
            return config;
        });
    }

    if (responseInterceptor == null) {
        responseInterceptor = axios.interceptors.response.use(
            response => {
                const url = response.config.url;
                // hideProgress(url);
                if (response.data.error) {
                    logError(url + '->error', response.data);
                    showError(response.data.error);
                    // dispatch(setLastErrorData(response.data));
                } else {
                    if (!url.includes("/download")) log(url + '->ok', response.data);
                    if (response.data.warning) {
                        showWarning(response.data.warning);
                    } else if (response.data.message) {
                        showInfo(response.data.message);
                    } else if (response.data.success) {
                        showSuccess(response.data.success);
                    }
                }
                // dispatch(setBusy(false));
                return response.data;
            },
            error => {
                // const testMode = true;
                // if (testMode) return testResponse(error.config.url);


                logError(error.config.url + '->catch', error);
                // hideProgress(error.config.url);
                // dispatch(setBusy(false));
                if (error?.response?.status == "401") {
                    dispatch(
                        setAuth({accessToken: '', refreshToken: ''})
                    );
                    saveToStore('access_token', '');
                    saveToStore('refresh_token', '');
                    showError(txt('register.accessDeniedPleaseLogin'));
                } else {
                    showError("" + error);
                }
                return Promise.reject(error);
            }
        );
    }

    // Окошко подтверждения операции, оформленное в стиле Promise
    const [confirmationDialogOptions, setConfirmationDialogOptions] = useState(null);
    const confirmationDialogOptionsAwaitingPromiseRef = useRef(null);
    const openConfirmationDialog = (options) => {
        setConfirmationDialogOptions(options)
        return new Promise((resolve, reject) => {
            confirmationDialogOptionsAwaitingPromiseRef.current = {resolve, reject};
        });
    };
    const hideConfirmationDialog = () => {
        setConfirmationDialogOptions(null)
        // setConfirmationDialogVisible(!confirmationDialogVisible)
    };
    const handleClose = () => {
        if (confirmationDialogOptionsAwaitingPromiseRef.current) confirmationDialogOptionsAwaitingPromiseRef.current.reject('canceled');
        hideConfirmationDialog();
    };
    const handleConfirm = () => {
        if (confirmationDialogOptionsAwaitingPromiseRef.current) confirmationDialogOptionsAwaitingPromiseRef.current.resolve('confirmed');
        hideConfirmationDialog();
    };


    // Окошко нижнего меню, оформленное в стиле Promise
    const [bottomMenuOptions, setBottomMenuOptions] = useState(null);
    const bottomMenuOptionsAwaitingPromiseRef = useRef(null);
    const openBottomMenu = (options) => {
        setBottomMenuOptions(options)
        return new Promise((resolve, reject) => {
            bottomMenuOptionsAwaitingPromiseRef.current = {resolve, reject};
        });
    };
    const hideBottomMenu = () => {
        setBottomMenuOptions(null)
        // setConfirmationDialogVisible(!confirmationDialogVisible)
    };
    const handleCloseBottomMenu = () => {
        if (bottomMenuOptionsAwaitingPromiseRef.current) bottomMenuOptionsAwaitingPromiseRef.current.reject('canceled');
        hideBottomMenu();
    };
    const handleConfirmBottomMenu = () => {
        if (bottomMenuOptionsAwaitingPromiseRef.current) bottomMenuOptionsAwaitingPromiseRef.current.resolve('confirmed');
        hideBottomMenu();
    };
    // const clearAllStates = () => { //todo maybe should add more here later, those are the ones that were causing problems showing all data for a moment after new login
    //     dispatch(setProviderList([]));
    //     dispatch(clearPerson());
    //     dispatch(clearProvider());
    //     dispatch(setCity(null));
    // }
    const categoryList = [
        {value: 'BEAUTY', label: translate('productCategory', 'BEAUTY')},
        {value: 'AUTO', label: translate('productCategory', 'AUTO')},
        {value: 'HEALTH', label: translate('productCategory', 'HEALTH')},
        {value: 'MEDICAL', label: translate('productCategory', 'MEDICAL')},
        // { value: 'CAFE', label: translate('productCategory', 'CAFE') },
        {value: 'EDUCATION', label: translate('productCategory', 'EDUCATION')},
        {value: 'FUN', label: translate('productCategory', 'FUN')},
        {value: 'ELECTRONIC', label: translate('productCategory', 'ELECTRONIC')},
        {value: 'TRAVEL', label: translate('productCategory', 'TRAVEL')},
        {value: 'HOME', label: translate('productCategory', 'HOME')},
        {value: 'FASHION', label: translate('productCategory', 'FASHION')},
        {value: 'INFO', label: translate('productCategory', 'INFO')},
        {value: 'OTHER', label: translate('productCategory', 'OTHER')},
    ];

    const genderList = [
        {value: 'MALE', label: translate('gender', 'MALE')},
        {value: 'FEMALE', label: translate('gender', 'FEMALE')},
        {value: 'OTHER', label: translate('gender', 'OTHER')},
    ];

    const firstWeekDayList = [
        {value: 'sunday', label: translate('firstWeekDay', 'sunday')},
        {value: 'monday', label: translate('firstWeekDay', 'monday')},
    ];

    const apiContextValue = {
        // функции для показа крутилки и сообщений пользователю
        showProgress: showProgress,
        hideProgress: hideProgress,
        showError: showError,
        showWarning: showWarning,
        showInfo: showInfo,
        showSuccess: showSuccess,

        saveToStore: saveToStore,
        getFromStore: getFromStore,
        afterLogin: afterLogin,
        doRefreshToken: doRefreshToken,
        //fixme clearAllStates: clearAllStates, // очистить все (большинство) стейты (после логаута)

        txt: txt,   // получить локализованную строку
        translate: translate,   // получить локалдизованную расшифровку мелкого справочника (на клиенте)
        // fixme getImageSource: getImageSource, // Получить ссылку на локальную картинку с учетом темы и локализации

        openConfirmationDialog: openConfirmationDialog,
        openBottomMenu: openBottomMenu,

        log: log,  // вывод сообщения в консоль
        logError: logError,  // вывод ошибки в консоль

        dictionary: () => dictionary(dispatch),

        //fixme saveTheme: saveTheme,

        // getSavedTheme: getSavedTheme,

        categoryList: categoryList, // список категорий
        genderList: genderList, // список гендеров
        firstWeekDayList: firstWeekDayList, // список первых дней недели
    };


    return (
        <ApiContext.Provider value={apiContextValue}>
            <AppLayout/>
            {/*<ConfirmationDialog*/}
            {/*    title={confirmationDialogOptions?.title}*/}
            {/*    message={confirmationDialogOptions?.message}*/}
            {/*    confirmTitle={confirmationDialogOptions?.confirmTitle}*/}
            {/*    cancelTitle={confirmationDialogOptions?.cancelTitle}*/}
            {/*    style={confirmationDialogOptions?.style}*/}
            {/*    onConfirm={handleConfirm}*/}
            {/*    onCancel={handleClose}*/}
            {/*    visible={confirmationDialogOptions != null}*/}
            {/*    setVisible={hideConfirmationDialog}*/}
            {/*    txt={txt}*/}
            {/*/>*/}
        </ApiContext.Provider>
    );
};

